import { Entity, Field } from "typegraph";

import { Image } from "./Image";

export default class User {

	@Field()
	public id: number;

	@Field()
	public externalId: string;

	@Field()
	public firstName: string;

	@Field()
	public lastName: string;

	@Field()
	public displayName: string;

	@Field()
	public email: string;

	@Field({entity: Image})
	public avatar: Image;

}



// WEBPACK FOOTER //
// ./src/panels/forum/entity/User.ts